import { RequisitionStatusType } from "./requisition-base.model";
import { BaseSearchModel } from "../query/base-search.model";
import { ClientSearchModel } from "../members/client/client-search-model";
import { ContactSearchModal } from "../contact/contacts-search.model";
import { TemplateDocumentType } from "../document/document-template-model";
import { UserSearchModel } from "../members/user/user-search.model";

export class RequisitionSearchModel extends BaseSearchModel {
        status?: RequisitionStatusType;
        createdById?: string;
        clientSearch?: ClientSearchModel;
        accountSearch?: ContactSearchModal;
        createdBySearch?: UserSearchModel;
        documentTypes?: TemplateDocumentType[];
        matterNumber?: string;
        number?: string;
        type?: string;
        assigneeIds?: string[];
        processedDateStart?: Date;
        processedDateEnd?: Date;
        //UI Only
        clientLimitedSearch?: string;
}






 